import { CameraSettings } from "src/common";

export const viewerPath = "view";

/* ------------------------------------ */
/*           SCENE SETTINGS            */
/* ------------------------------------ */
export const scenePath = "2414718.json";

/* ------------------------------------ */
/*    VIEWER CAMERA FRAMING CONSTANTS   */
/* ------------------------------------ */

// Multiplicative breathing room on the fit distance — 1.05 leaves ~5% margin
// around the product so it doesn't touch the viewport edges.
export const viewerCameraPaddingFactor = 1.05;

// Additive buffer on the dolly upper-bound only — lets the user zoom out a bit
// past the fit distance. Does NOT affect the initial framing.
export const viewerCameraMaxDistancePadding = 2;

// Initial orbit angles (degrees) — slight three-quarter view. Used both for
// `View.setOrbit()` and for the projected-bbox fit math.
export const viewerInitialOrbit = { pitch: 25, yaw: 25 } as const;

/* ------------------------------------ */
/*           CAMERA SETTINGS            */
/* ------------------------------------ */
export const cameraSettings: CameraSettings = {
	fov: 37.8,
	farClip: 40,
	nearClip: 0.2,
	maxDistance: 3,
	minDistance: 1.1,
	floorPosition: 0.1,
	maxElevation: 180,
	minElevation: -180,
	allowPan: false,
	allowOrbit: true,
	allowDolly: true,
};
